
const digest = '420d2079cd1474081402765f598b26d5c5c24bebdbd5b68253126bbfa9a08937';
const css = `._image_2a3jv_1 {
  display: inline-block;
  position: relative;
  max-width: 100%;
  text-align: center;
}
._imageElement_2a3jv_7 {
  box-sizing: border-box;
}

._imageInline_2a3jv_11 {
  display: inline-block;
  margin: 0.2em;
  max-width: 100%;
}

._imageBlock_2a3jv_17 {
  display: block;
  text-align: center;
  margin: 0.2em;
}

._loader_2a3jv_23 {
  container-type: size;
  position: absolute;
  inset: 0;
  background-color: rgba(
    var(--theme-rgb-primary-background, 255, 255, 255),
    0.25
  );
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

._loaderInline_2a3jv_37 {
  pointer-events: none;
  display: inline-block;
  margin-right: 0.25rem;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"image":"_image_2a3jv_1","imageElement":"_imageElement_2a3jv_7","imageInline":"_imageInline_2a3jv_11","imageBlock":"_imageBlock_2a3jv_17","loader":"_loader_2a3jv_23","loaderInline":"_loaderInline_2a3jv_37"};
export { css, digest };
  